import axios from './axios';
import common from './common.js';
// 引入组件
import keep from '../components/keep.vue';
import tButtontab from '../components/buttontab.vue';
import tCopyright from '../components/custom/copyright.vue';
import tNumber from '../components/number.vue';
import tSearch from '../components/search.vue';
import tCircle from '../components/custom/circle.vue';
import tHeader from '../components/header.vue';
import tField from '../components/field.vue';
import tSwitch from '../components/switch.vue';
import tNavbar from '../components/navbar.vue';
import tNavitem from '../components/navitem.vue';
import tSelect from '../components/select.vue';
import tSelectbox from '../components/selectbox.vue';
import tSelectitem from '../components/selectitem.vue';
import tScrollmore from '../components/scrollmore.vue';
import tMore from '../components/more.vue';
import tLoading from '../components/loading.vue';
import tPanel from '../components/panel.vue';
import tSliderbox from '../components/sliderbox.vue';
import tButton from '../components/button.vue';
import tBadge from '../components/badge.vue';
import tTab from '../components/tab.vue';
import tEmpty from '../components/custom/empty.vue';
import tUpload from '../components/upload.vue';
import tFlow from '../components/flow.vue';
import tGrid from '../components/grid.vue';
import tGriditem from '../components/griditem.vue';
import tGoods from '../components/custom/goods.vue';
import tGoodsbox from '../components/custom/goodsbox.vue';
import betterScroll from '../components/betterscroll.vue';
import swiper from '../components/swiper.vue';
import swiperSlide from '../components/swiperslide.vue';
import tGroup from '../components/group.vue';
import tHead from '../components/layout/head.vue';
import tFoot from '../components/layout/foot.vue';
import tPages from '../components/layout/pages.vue';
import tNavleft from '../components/layout/navleft.vue';



export default {
  install(Vue, store, router) {
    // 总线, 挂载全局Bus上，可同过this.Bus.$emit(), this.Bus.$on()进行跨组件通讯
    const bus = new Vue();
    // 路由返回管理
    const routerGo = router.go.bind(router);
    router.go = (n) => {
      store.commit('REFRESH', false);
      routerGo(n);
    };
    // 模块动态注册
    store.registerModule('vm', {
      state: {
        isLoading: false, // 加载动画
        direction: '', // 划入(in)划出(out)
        routeData: {}, // 跳转的路由信息
        history: { '/': 1 }, // 历史路由管理
        historyCount: 1, // 路由数量
        includeList: [], // 缓存路由
        refresh: true, // 是否刷新缓存
      },
      mutations: {
        // 加载状态
        ISLOADING(state, payload) {
          state.isLoading = payload;
        },
        // 滑动方向
        DIRECTION(state, payload) {
          state.direction = payload;
        },
        // 跳转路由信息
        ROUTE: (state, payload) => {
          state.routeData = payload;
        },
        // 历史路由编号管理
        HISTORY: (state, payload) => {
          state.history = payload;
        },
        // 历史路由数量
        HISTORYCOUNT: (state, payload) => {
          state.historyCount = payload;
        },
        // 缓存页面数组
        INCLUDELIST: (state, payload) => {
          state.includeList = payload;
        },
        // 刷新缓存
        REFRESH: (state, payload) => {
          state.refresh = payload;
        },
      },
    });
    // 全局组件
    const componentList = [
      keep,
      tPanel,
      tHeader,
      tSwitch,
      tNavbar,
      tNavitem,
      tSelect,
      tField,
      tSliderbox,
      tSelectbox,
      tSelectitem,
      tScrollmore,
      tLoading,
      tMore,
      tButton,
      tBadge,
      tButtontab,
      tCircle,
      tNumber,
      tSearch,
      tCopyright,
      tTab,
      tEmpty,
      tUpload,
      tFlow,
      tGrid,
      tGriditem,
      tGoods,
      tGoodsbox,
      betterScroll,
      swiper,
      swiperSlide,
      tGroup,
      tHead,
      tFoot,
      tPages,
      tNavleft
    ];
    // 挂载全局方法
    Vue.prototype.Bus = bus;
    Vue.prototype.$http = axios;
    for (const key in common) {
      Vue.prototype[`$${key}`] = common[key];
    }
    // 挂载全局组件
    componentList.forEach((t) => {
      Vue.component(t.name, t);
    });
    // 自定义指令
    // 组件内VNODE更新都会调用update,而非是绑定的div,但只能触发当前组件，不能触发父组件
    // 填充占位指令：v-fill = "{fill: true, height: '200px'} 只适应于内容异步加载，静态内容使用可能会出现未知异常,尤其是swiper类似插件
    Vue.directive('fill', {
      bind(el, binding) {
        el.dataset.fill = 'fill';
        const bindValue = binding.value || {};
        if (bindValue.fill) {
          el.childNodes.forEach((item) => {
            if (item && item.style) {
              const originClass = item.getAttribute('class') || '';
              item.setAttribute('class', `hide ${originClass}`);
            }
          });
          const divNode = document.createElement('div');
          divNode.setAttribute('class', 'mask');
          divNode.style.width = bindValue.width || '100%';
          divNode.style.height = bindValue.height || '100%';
          divNode.style.backgroundColor = bindValue.backgroundColor || '#eee';
          el.appendChild(divNode);
        }
      },
      update(el, binding) {
        const bindValue = binding.value || {};
        if (el.dataset.fill && !bindValue.fill) {
          el.dataset.fill = '';
          el.childNodes.forEach((item) => {
            if (item && item.style) {
              if (item.getAttribute('class') === 'mask') {
                el.removeChild(item);
              }
              let originClass = item.getAttribute('class') || ' ';
              originClass = originClass.replace('hide', '').slice(1);
              if (originClass) {
                item.setAttribute('class', originClass);
              } else {
                item.removeAttribute('class');
              }
            }
          });
        }
      },
    });
    // 自动获取光标指令: v-focus
    Vue.directive('focus', {
      inserted(el) {
        el.focus();
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/config/plugin.js